import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import homepageImage10 from "../../images/homePageImages/homepageimage10.png";
import homepageImage8 from "../../images/homePageImages/homepageimage8.png";
import homepageImage11 from "../../images/homePageImages/homepageimage11.png";

import "./businessLanding.css";
import PhoneCarousel from "../common/phoneCarousel/PhoneCarousel";

const BusinessLanding = () => {
	const { language } = useContext(CombinedContext);
	const navigate = useNavigate();

	const t = translations[language].businessLanding;

	return (
		<div>
			{/* HERO */}
			<section className="sf-bl-hero">
				<div className="sf-bl-hero-orb1"></div>
				<div className="sf-bl-hero-orb2"></div>
				<div className="sf-bl-hero-inner">
					<div className="sf-bl-hero-left">
						<div className="sf-bl-hero-badge">
							<span className="sf-bl-hero-badge-dot"></span>
							{t.misc.badge}
						</div>

						<h1>{t.hero.title}</h1>

						<p className="sf-bl-hero-sub">{t.hero.subtitle}</p>

						<div className="sf-bl-hero-buttons">
							<button className="sf-bl-btn-primary" onClick={() => navigate("/listyourshop")}>
								{t.hero.primaryCta}
							</button>
							<button className="sf-bl-btn-ghost">{t.hero.storeText}</button>
						</div>

						<p className="sf-bl-hero-note">
							<em>
								<strong>{t.hero.noteStrong}</strong>
								{t.hero.noteRest}
							</em>
						</p>
					</div>

					<div className="sf-bl-hero-img-wrap">
						<img src={homepageImage10} alt="" className="sf-bl-hero-img" />
					</div>
				</div>
			</section>

			{/* PAGE BODY */}
			<div className="sf-bl-page">
				{/* PROBLEM */}
				<section className="sf-bl-problem">
					<div className="sf-bl-section-head sf-bl-center">
						<span className="sf-bl-section-label">{t.misc.labelChallenge}</span>
						<h2>{t.problem.title}</h2>
					</div>

					<div className="sf-bl-problem-grid">
						<div className="sf-bl-pcard sf-bl-pcard-red">
							{/* <div className="sf-bl-pcard-icon sf-bl-pcard-icon-red">😓</div> */}
							<h3>{t.problem.subtitle}</h3>
							<ul>
								{t.problem.items.map((item, i) => (
									<li key={i}>
										<div className="sf-bl-dot sf-bl-dot-red"></div>
										{item}
									</li>
								))}
							</ul>
						</div>

						<div className="sf-bl-pcard sf-bl-pcard-blue">
							{/* <div className="sf-bl-pcard-icon sf-bl-pcard-icon-blue">📊</div> */}
							<h3>{t.problem.description}</h3>
							<ul>
								{t.problem.itemspart2.map((item, i) => (
									<li key={i}>
										<div className="sf-bl-dot sf-bl-dot-blue"></div>
										{item}
									</li>
								))}
							</ul>
							<div className="sf-bl-problem-highlight">
								<span className="sf-bl-hl-icon">⚠️</span>
								<p>{t.problem.highlight}</p>
							</div>
						</div>
					</div>
				</section>

				{/* DID YOU KNOW */}
				<section className="sf-bl-didyouknow">
					<div className="sf-bl-dyk-inner">
						<div className="sf-bl-dyk-left">
							<span className="sf-bl-section-label">{t.misc.labelResearch}</span>
							<h2>{t.didYouKnow.title}</h2>
							<ul className="sf-bl-dyk-list">
								{t.didYouKnow.items.map((item, i) => (
									<li key={i}>
										<span className="sf-bl-dyk-bullet">•</span>
										{item}
									</li>
								))}
							</ul>
							<div className="sf-bl-didyouknow-highlight">{t.didYouKnow.highlight}</div>
						</div>
						<img src={homepageImage8} alt="" className="sf-bl-dyk-img" />
					</div>
				</section>

				{/* SOLUTION */}
				<section className="sf-bl-solution">
					<div className="sf-bl-section-head sf-bl-center">
						<span className="sf-bl-section-label">{t.misc.labelHowItWorks}</span>
						<h2>{t.solution.title}</h2>
					</div>

					<div className="sf-bl-solution-grid">
						<ul className="sf-bl-solution-steps">
							{t.solution.points.map((p, i) => (
								<li key={i} className="sf-bl-step-item">
									<div className="sf-bl-step-num">{i + 1}</div>
									<div className="sf-bl-step-content">
										<strong>{p.title}</strong>
										<p>{p.desc}</p>
									</div>
								</li>
							))}
						</ul>

						<div className="sf-bl-solution-phone">
							<div className="sf-bl-sol-glow"></div>
							<PhoneCarousel />
						</div>
					</div>
				</section>

				{/* PRICING */}
				<section className="sf-bl-pricing">
					<div className="sf-bl-section-head sf-bl-center">
						<span className="sf-bl-section-label">{t.misc.labelPricing}</span>
						<h2>{t.pricing.title}</h2>
					</div>

					<div className="sf-bl-pricing-grid">
						<div className="sf-bl-pricing-card sf-bl-pricing-card-dark">
							<h3>{t.pricing.planTitle}</h3>
							<div className="sf-bl-price-row">
								<span className="sf-bl-price-big">{translations[language].businessLanding.pricing.priceNote}</span>
							</div>
							<ul>
								{t.pricing.planItems.map((p, i) => (
									<li key={i}>
										<span className="sf-bl-ck">✓</span>
										{p}
									</li>
								))}
							</ul>
							<p className="sf-bl-pricing-note">{t.pricing.note}</p>
						</div>

						<div className="sf-bl-pricing-card-other">
							<h3>{t.pricing.autoTitle}</h3>
							<div className="sf-bl-auto-list">
								{t.pricing.autoItems.map((a, i) => (
									<div key={i} className="sf-bl-auto-li">
										<div className="sf-bl-auto-ic">{i === 0 ? "💳" : i === 1 ? "🔄" : "✓"}</div>
										{a}
									</div>
								))}
							</div>
						</div>
					</div>
				</section>

				{/* REFERRAL */}
				<section className="sf-bl-referral">
					<div className="sf-bl-referral-banner">
						<p>{t.referral.banner}</p>
						<span className="sf-bl-gold-tag">{t.misc.freeMonthsTag}</span>
					</div>

					<div className="sf-bl-referral-grid">
						<div className="sf-bl-ref-img-wrap">
							<img src={homepageImage11} alt="" className="sf-bl-ref-img" />
						</div>
						<div className="sf-bl-ref-steps">
							{t.referral.steps.map((s, i, arr) => {
								const isNote = i === arr.length - 1;
								return (
									<div key={i} className={`sf-bl-ref-step${isNote ? " sf-bl-ref-note" : ""}`}>
										{!isNote && <div className="sf-bl-ref-num">{i + 1}</div>}
										<p>{s}</p>
									</div>
								);
							})}
						</div>
					</div>
				</section>

				{/* FINAL CTA */}
				<section className="sf-bl-final">
					<p>{t.final.text}</p>
					<button className="sf-bl-btn-primary" onClick={() => navigate("/listyourshop")}>
						{t.final.button}
					</button>
				</section>
			</div>
		</div>
	);
};

export default BusinessLanding;
